import React from "react";
import { Col, Container, Image, Row, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import ContactForm from "../components/ContactForm";
import ContactMap from "../components/ContactMap";

const ContactInfo = () => {
    return (
        <>
        <Container className="contact-content">
            <Row className="justify-content-center">
                <Col md="12">
                    <h2>Get In Touch</h2>
                </Col>
                <Col md="4">
                    <Stack className="contact-items flex-wrap flex-row">
                        <Stack className="contact-items-img">
                            <Image src="/images/location-sign.svg" />
                        </Stack>
                        <span>
                            509, Gala Empire, Opp. TV Tower, Near Drive In Rd, Gurukul, Ahmedabad, Gujarat 380052
                        </span>
                    </Stack>
                    <Stack className="contact-items flex-wrap flex-row">
                        <Stack className="contact-items-img">
                            <Image src="/images/phone-icon.svg" />
                        </Stack>
                        <span>
                            <Link to="tel:+91 8153091948">
                                (+91) - 8153091948
                            </Link>
                        </span>
                    </Stack>
                    <Stack className="contact-items flex-wrap flex-row">
                        <Stack className="contact-items-img">
                            <Image src="/images/email-icon.svg" />
                        </Stack>
                        <span>
                            <Link to="mailto:sales@webiletechnologies.com">
                                sales@webiletechnologies.com
                            </Link>
                        </span>
                    </Stack>
                </Col>
                <Col md="6">
                    <ContactForm />
                </Col>
            </Row>
        </Container>
        <ContactMap />
        </>
    )
}

export default ContactInfo;